import PoolsApi from '../api/pools'

export const LOAD_LOGS_REQUESTED = 'poolDetails/LOAD_LOGS_REQUESTED'
export const LOAD_LOGS = 'poolDetails/LOAD_LOGS'
export const LOAD_LOGS_ERROR = 'poolDetails/LOAD_LOGS_ERROR'

export const LOADPOOL_REQUESTED = 'poolsDetails/LOADPOOL_REQUESTED'
export const LOADPOOL = 'poolsDetails/LOADPOOL'
export const LOADPOOL_ERROR = 'poolsDetails/LOADPOOL_ERROR'

export const LOAD_POOLSUMMARY_REQUESTED = 'poolDetails/LOAD_POOLSUMMARY_REQUESTED'
export const LOAD_POOLSUMMARY = 'poolDetails/LOAD_POOLSUMMARY'
export const LOAD_POOLSUMMARY_ERROR = 'poolDetails/LOAD_POOLSUMMARY_ERROR'

export const loadPoolSummaryAsync = (data) => {
  return async dispatch => {
    dispatch({
      type: LOAD_POOLSUMMARY_REQUESTED,
      id: data.id,
      user: data.user
    })

    try {
      const poolSummaryResponse = await PoolsApi.PoolSummary(data.id, data.user)
      const poolSummaryJson = await poolSummaryResponse.json()
      
      const poolThresholdResponse = await PoolsApi.GetThresholds(data.id)
      let thresholdJson = {
        offlineThreshold: null,
        onlineThreshold: null,
        isDefault: true
      }

      if (poolThresholdResponse.ok) {
        thresholdJson = await poolThresholdResponse.json()
      }

      const now = new Date()
      const oneWeekAgo = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000)
      const poolModeResponse = await PoolsApi.GetLogs(data.id, 0, 1000000, 'PoolRiskLevel', oneWeekAgo.toISOString(), now.toISOString())
      const poolModeRaw = await poolModeResponse.json()
      if(poolModeRaw.data.length > 0){
        poolSummaryJson.riskLevelData = poolModeRaw.data
      }

      poolSummaryJson.offlineThreshold = thresholdJson.offlineThreshold
      poolSummaryJson.onlineThreshold = thresholdJson.onlineThreshold
      poolSummaryJson.isDefault = thresholdJson.isDefault
      
      return dispatch({ type: LOAD_POOLSUMMARY, data: poolSummaryJson, user: data.user})
    }
    catch (error) {
      console.log('There has been a problem with your fetch operation: ', error)
      return dispatch({type: LOAD_POOLSUMMARY_ERROR, error: error.message })
    }
  }
}
 
export const loadLogsAsync = (data) => {
  return dispatch => {
    dispatch({
      type: LOAD_LOGS_REQUESTED,
      id: data.id,
      page: data.page,
      itemsPerPage: data.itemsPerPage,
      user: data.user,
      eventType: data.eventType,
      occurredStartDate: data.occurredStartDate,
      occurredEndDate: data.occurredEndDate
    })
  
    let offset = (data.page - 1) * data.itemsPerPage
  
    PoolsApi.GetLogs(data.id, offset, data.itemsPerPage, data.eventType, data.occurredStartDate, data.occurredEndDate)
      .then(response => {
        return response.json()
      })
      .then(json => dispatch({
        type: LOAD_LOGS,
        data: json,
        user: data.user
      }))
      .catch(function (error) {
        dispatch({
          type: LOAD_LOGS_ERROR,
          error: error.message
        })
        console.log('There has been a problem with your fetch operation: ', error)
      })
  }
}

export const loadPool = (data) => {
  return dispatch => {
    dispatch({
      type: LOADPOOL,
      data: data,
      user: data.user
    })
  }
}
  
export const loadPoolAsync = (data) => {
  return dispatch => {
    dispatch({
      type: LOADPOOL_REQUESTED,
      id: data.id,
      user: data.user
    })
  
    PoolsApi.GetById(data.id, data.user)
      .then(response => response.json())
      .then(json => dispatch(loadPool(json)))
      .catch(function (error) {
        dispatch({
          type: LOADPOOL_ERROR,
          error: error.message
        })
        console.log('There has been a problem with your fetch operation: ', error)
      })
  }
}

   



// WEBPACK FOOTER //
// ./src/actions/poolDetails.js